import { render, staticRenderFns } from "./TurnPreference.html?vue&type=template&id=598a811f&external"
import script from "./TurnPreference.ts?vue&type=script&lang=ts&external"
export * from "./TurnPreference.ts?vue&type=script&lang=ts&external"
import style0 from "./TurnPreference.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports